import { reduxForm } from 'redux-form';
import Component from './Login';
import validate from './validate';

const initialValues = {
  username: '',
  password: '',
  token: '',
};

const Form = reduxForm({
  form: 'login',
  initialValues,
  validate,
})(Component);

export default Form;
